import { IBoardType, IIssueBoardApi } from "@schemas/issueBoardSchema";
import { ColDef } from "ag-grid-community";
import React from "react";
import { FailedAlert, MCLoader } from "../../../../components";
import ViewEditTable from "../../../../components/ViewEditTable/ViewEditTable";
import { VETEmptyValidator } from "../../../../components/ViewEditTable/ViewEditTableValidators";
import { useAppSelector } from "../../../../hooks";
import { useUpdateIssueBoardTypesMutation } from "../IssueBoardRTK";
import SettingsCardWrapper from "./SettingsCardWrapper";

const IssueBoardTypes: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const types: IBoardType[] = issueBoard.types;
  const [data, setData] = React.useState<IBoardType[]>(types);
  const [updateTypes, { isLoading, error }] = useUpdateIssueBoardTypesMutation();

  const colDefs: ColDef<IBoardType>[] = [
    {
      field: "name",
      headerName: "Navn",
      editable: true,
    },
  ];

  React.useEffect(() => {
    const _data = types.map((item) => ({ name: item.name }));
    setData(_data);
  }, [types]);

  const newItemTemplateObject = {
    name: "",
  };

  const saveTypes = async (types: { name: string }[]) => {
    if (types.length === 0) {
      setData([...data]);
      return alert("Du må ha minst en type");
    }

    updateTypes({
      projectId: project._id,
      issueBoardId: issueBoard._id,
      types,
    });
  };

  return (
    <SettingsCardWrapper title="Typer">
      {isLoading === true && <MCLoader loading={isLoading} />}
      {error != null && <FailedAlert />}
      {error == null && (
        <>
          {data != null && (
            <ViewEditTable
              columns={colDefs}
              data={data}
              onSave={saveTypes}
              newItemTemplateObject={newItemTemplateObject}
              canEdit={true}
              validators={[VETEmptyValidator]}
            />
          )}
        </>
      )}
    </SettingsCardWrapper>
  );
};

export default IssueBoardTypes;
